/* tslint:disable */
/* eslint-disable */
/**
 * Spaces
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 *
 * @export
 * @interface InlineObject
 */
export interface InlineObject {
  /**
   *
   * @type {number}
   * @memberof InlineObject
   */
  afterStepId?: number;
}
/**
 *
 * @export
 * @interface InlineObject1
 */
export interface InlineObject1 {
  /**
   *
   * @type {string}
   * @memberof InlineObject1
   */
  type?: InlineObject1TypeEnum;
  /**
   *
   * @type {number}
   * @memberof InlineObject1
   */
  stepId?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineObject1
   */
  order?: number;
  /**
   *
   * @type {object}
   * @memberof InlineObject1
   */
  content?: object;
  /**
   *
   * @type {number}
   * @memberof InlineObject1
   */
  publishAt?: number | null;
  /**
   *
   * @type {boolean}
   * @memberof InlineObject1
   */
  isDraft?: boolean;
}

export const InlineObject1TypeEnum = {
  Intro: 'intro',
  Step: 'step',
  Finish: 'finish',
  Deferred: 'deferred',
} as const;

export type InlineObject1TypeEnum = typeof InlineObject1TypeEnum[keyof typeof InlineObject1TypeEnum];

/**
 *
 * @export
 * @interface InlineObject2
 */
export interface InlineObject2 {
  /**
   *
   * @type {string}
   * @memberof InlineObject2
   */
  type?: InlineObject2TypeEnum;
  /**
   *
   * @type {number}
   * @memberof InlineObject2
   */
  stepId?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineObject2
   */
  order?: number;
  /**
   *
   * @type {object}
   * @memberof InlineObject2
   */
  content?: object;
  /**
   *
   * @type {number}
   * @memberof InlineObject2
   */
  publishAt?: number | null;
  /**
   *
   * @type {boolean}
   * @memberof InlineObject2
   */
  isDraft?: boolean;
}

export const InlineObject2TypeEnum = {
  Intro: 'intro',
  Step: 'step',
  Finish: 'finish',
  Deferred: 'deferred',
} as const;

export type InlineObject2TypeEnum = typeof InlineObject2TypeEnum[keyof typeof InlineObject2TypeEnum];

/**
 *
 * @export
 * @interface InlineObject3
 */
export interface InlineObject3 {
  /**
   *
   * @type {Array<number>}
   * @memberof InlineObject3
   */
  deleted?: Array<number>;
  /**
   *
   * @type {Array<InlineObject2>}
   * @memberof InlineObject3
   */
  created?: Array<InlineObject2>;
  /**
   *
   * @type {Array<SpacesSpaceIdChallengePostsUpdated>}
   * @memberof InlineObject3
   */
  updated?: Array<SpacesSpaceIdChallengePostsUpdated>;
}
/**
 *
 * @export
 * @interface InlineObject4
 */
export interface InlineObject4 {
  /**
   *
   * @type {Array<number>}
   * @memberof InlineObject4
   */
  deleted?: Array<number>;
  /**
   *
   * @type {Array<SpacesSpaceIdChallengeStepsCreated>}
   * @memberof InlineObject4
   */
  created?: Array<SpacesSpaceIdChallengeStepsCreated>;
  /**
   *
   * @type {Array<SpacesSpaceIdChallengeStepsUpdated>}
   * @memberof InlineObject4
   */
  updated?: Array<SpacesSpaceIdChallengeStepsUpdated>;
}
/**
 *
 * @export
 * @interface InlineObject5
 */
export interface InlineObject5 {
  /**
   *
   * @type {string}
   * @memberof InlineObject5
   */
  slug?: string | null;
  /**
   *
   * @type {string}
   * @memberof InlineObject5
   */
  title?: string | null;
  /**
   *
   * @type {number}
   * @memberof InlineObject5
   */
  price?: number | null;
  /**
   *
   * @type {string}
   * @memberof InlineObject5
   */
  status?: InlineObject5StatusEnum;
  /**
   *
   * @type {string}
   * @memberof InlineObject5
   */
  payment_type?: InlineObject5PaymentTypeEnum;
  /**
   *
   * @type {number}
   * @memberof InlineObject5
   */
  coverFileId?: number | null;
  /**
   *
   * @type {SpacesSpaceIdConfig}
   * @memberof InlineObject5
   */
  config?: SpacesSpaceIdConfig | null;
}

export const InlineObject5StatusEnum = {
  Draft: 'draft',
  Published: 'published',
} as const;

export type InlineObject5StatusEnum = typeof InlineObject5StatusEnum[keyof typeof InlineObject5StatusEnum];
export const InlineObject5PaymentTypeEnum = {
  FixedPrice: 'fixed_price',
  FixedPriceSubscribersOnly: 'fixed_price_subscribers_only',
  SubscribersOnly: 'subscribers_only',
  Free: 'free',
  MonthlyPrice: 'monthly_price',
} as const;

export type InlineObject5PaymentTypeEnum =
  typeof InlineObject5PaymentTypeEnum[keyof typeof InlineObject5PaymentTypeEnum];

/**
 *
 * @export
 * @interface InlineObject6
 */
export interface InlineObject6 {
  /**
   *
   * @type {string}
   * @memberof InlineObject6
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof InlineObject6
   */
  type?: InlineObject6TypeEnum;
  /**
   *
   * @type {number}
   * @memberof InlineObject6
   */
  coverFileId?: number;
  /**
   *
   * @type {string}
   * @memberof InlineObject6
   */
  payment_type?: InlineObject6PaymentTypeEnum;
  /**
   *
   * @type {string}
   * @memberof InlineObject6
   */
  slug?: string | null;
  /**
   *
   * @type {number}
   * @memberof InlineObject6
   */
  price?: number;
  /**
   *
   * @type {SpacesConfig1}
   * @memberof InlineObject6
   */
  config?: SpacesConfig1 | null;
}

export const InlineObject6TypeEnum = {
  Post: 'post',
  Live: 'live',
  Challenge: 'challenge',
  Trailer: 'trailer',
  Channel: 'channel',
} as const;

export type InlineObject6TypeEnum = typeof InlineObject6TypeEnum[keyof typeof InlineObject6TypeEnum];
export const InlineObject6PaymentTypeEnum = {
  FixedPrice: 'fixed_price',
  FixedPriceSubscribersOnly: 'fixed_price_subscribers_only',
  SubscribersOnly: 'subscribers_only',
  Free: 'free',
  MonthlyPrice: 'monthly_price',
} as const;

export type InlineObject6PaymentTypeEnum =
  typeof InlineObject6PaymentTypeEnum[keyof typeof InlineObject6PaymentTypeEnum];

/**
 *
 * @export
 * @interface InlineResponse200
 */
export interface InlineResponse200 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse200
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse200
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse200
   */
  updatedAt?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse200
   */
  challengeSpace?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse200
   */
  previousStep?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse200
   */
  content?: number;
}
/**
 *
 * @export
 * @interface InlineResponse2001
 */
export interface InlineResponse2001 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2001
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2001
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2001
   */
  updatedAt?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2001
   */
  deletedAt?: number | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2001
   */
  type?: InlineResponse2001TypeEnum;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2001
   */
  spaceId?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2001
   */
  stepId?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2001
   */
  order?: number;
  /**
   *
   * @type {object}
   * @memberof InlineResponse2001
   */
  content?: object;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2001
   */
  gsMessageId?: string | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2001
   */
  publishAt?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2001
   */
  publishedAt?: number | null;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2001
   */
  isDraft?: boolean;
}

export const InlineResponse2001TypeEnum = {
  Intro: 'intro',
  Step: 'step',
  Finish: 'finish',
  Deferred: 'deferred',
} as const;

export type InlineResponse2001TypeEnum = typeof InlineResponse2001TypeEnum[keyof typeof InlineResponse2001TypeEnum];

/**
 *
 * @export
 * @interface InlineResponse20010
 */
export interface InlineResponse20010 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20010
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20010
   */
  created_at?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20010
   */
  updated_at?: number | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20010
   */
  title?: string;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20010
   */
  price?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20010
   */
  type?: InlineResponse20010TypeEnum;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20010
   */
  status?: InlineResponse20010StatusEnum;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20010
   */
  payment_type?: InlineResponse20010PaymentTypeEnum;
  /**
   *
   * @type {InlineResponse2006Config}
   * @memberof InlineResponse20010
   */
  config?: InlineResponse2006Config | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20010
   */
  slug?: string;
  /**
   *
   * @type {InlineResponse2006ConfigLiveRecordVideo}
   * @memberof InlineResponse20010
   */
  cover?: InlineResponse2006ConfigLiveRecordVideo | null;
}

export const InlineResponse20010TypeEnum = {
  Post: 'post',
  Live: 'live',
  Challenge: 'challenge',
  Trailer: 'trailer',
  Channel: 'channel',
} as const;

export type InlineResponse20010TypeEnum = typeof InlineResponse20010TypeEnum[keyof typeof InlineResponse20010TypeEnum];
export const InlineResponse20010StatusEnum = {
  Draft: 'draft',
  Published: 'published',
} as const;

export type InlineResponse20010StatusEnum =
  typeof InlineResponse20010StatusEnum[keyof typeof InlineResponse20010StatusEnum];
export const InlineResponse20010PaymentTypeEnum = {
  FixedPrice: 'fixed_price',
  FixedPriceSubscribersOnly: 'fixed_price_subscribers_only',
  SubscribersOnly: 'subscribers_only',
  Free: 'free',
  MonthlyPrice: 'monthly_price',
} as const;

export type InlineResponse20010PaymentTypeEnum =
  typeof InlineResponse20010PaymentTypeEnum[keyof typeof InlineResponse20010PaymentTypeEnum];

/**
 *
 * @export
 * @interface InlineResponse20011
 */
export interface InlineResponse20011 {
  /**
   *
   * @type {string}
   * @memberof InlineResponse20011
   */
  path?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20011
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20011
   */
  type?: string;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20011
   */
  size?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20011
   */
  mime?: string;
  /**
   *
   * @type {object}
   * @memberof InlineResponse20011
   */
  meta?: object;
}
/**
 *
 * @export
 * @interface InlineResponse2002
 */
export interface InlineResponse2002 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2002
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2002
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2002
   */
  updatedAt?: number | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2002
   */
  type?: InlineResponse2002TypeEnum;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2002
   */
  spaceId?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2002
   */
  stepId?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2002
   */
  order?: number;
  /**
   *
   * @type {object}
   * @memberof InlineResponse2002
   */
  content?: object;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2002
   */
  publishAt?: number | null;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2002
   */
  isDraft?: boolean;
}

export const InlineResponse2002TypeEnum = {
  Intro: 'intro',
  Step: 'step',
  Finish: 'finish',
  Deferred: 'deferred',
} as const;

export type InlineResponse2002TypeEnum = typeof InlineResponse2002TypeEnum[keyof typeof InlineResponse2002TypeEnum];

/**
 *
 * @export
 * @interface InlineResponse2003
 */
export interface InlineResponse2003 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2003
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2003
   */
  name?: string;
  /**
   *
   * @type {SpacesSpaceIdChallengeResultsAvatar}
   * @memberof InlineResponse2003
   */
  avatar?: SpacesSpaceIdChallengeResultsAvatar | null;
}
/**
 *
 * @export
 * @interface InlineResponse2004
 */
export interface InlineResponse2004 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2004
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2004
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2004
   */
  updatedAt?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2004
   */
  challengeSpace?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2004
   */
  title?: string;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2004
   */
  markAsCompletedForm?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2004
   */
  feedbackForm?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2004
   */
  startAt?: number | null;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2004
   */
  isEnabled?: boolean;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2004
   */
  estimatedEffort?: number;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2004
   */
  isSignificant?: boolean;
}
/**
 *
 * @export
 * @interface InlineResponse2005
 */
export interface InlineResponse2005 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2005
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2005
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2005
   */
  updatedAt?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2005
   */
  challengeSpace?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2005
   */
  type?: InlineResponse2005TypeEnum;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2005
   */
  title?: string;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2005
   */
  markAsCompletedForm?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2005
   */
  feedbackForm?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2005
   */
  startAt?: number | null;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2005
   */
  isEnabled?: boolean;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2005
   */
  estimatedEffort?: number;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2005
   */
  isSignificant?: boolean;
}

export const InlineResponse2005TypeEnum = {
  Post: 'post',
  LiveStream: 'live_stream',
} as const;

export type InlineResponse2005TypeEnum = typeof InlineResponse2005TypeEnum[keyof typeof InlineResponse2005TypeEnum];

/**
 *
 * @export
 * @interface InlineResponse2006
 */
export interface InlineResponse2006 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2006
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2006
   */
  club?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2006
   */
  title?: string;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2006
   */
  price?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2006
   */
  creatorPrice?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2006
   */
  type?: InlineResponse2006TypeEnum;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2006
   */
  payment_type?: InlineResponse2006PaymentTypeEnum;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2006
   */
  coverFileId?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2006
   */
  priceModel?: InlineResponse2006PriceModelEnum;
  /**
   *
   * @type {object}
   * @memberof InlineResponse2006
   */
  priceConfig?: object | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2006
   */
  iosProductId?: string | null;
  /**
   *
   * @type {InlineResponse2006Config}
   * @memberof InlineResponse2006
   */
  config?: InlineResponse2006Config | null;
  /**
   *
   * @type {InlineResponse2006MarketingPriceConfig}
   * @memberof InlineResponse2006
   */
  marketingPriceConfig?: InlineResponse2006MarketingPriceConfig | null;
  /**
   *
   * @type {Array<InlineResponse2006Steps>}
   * @memberof InlineResponse2006
   */
  steps?: Array<InlineResponse2006Steps>;
  /**
   *
   * @type {Array<InlineResponse2006Posts>}
   * @memberof InlineResponse2006
   */
  posts?: Array<InlineResponse2006Posts>;
}

export const InlineResponse2006TypeEnum = {
  Post: 'post',
  Live: 'live',
  Challenge: 'challenge',
  Trailer: 'trailer',
  Channel: 'channel',
} as const;

export type InlineResponse2006TypeEnum = typeof InlineResponse2006TypeEnum[keyof typeof InlineResponse2006TypeEnum];
export const InlineResponse2006PaymentTypeEnum = {
  FixedPrice: 'fixed_price',
  FixedPriceSubscribersOnly: 'fixed_price_subscribers_only',
  SubscribersOnly: 'subscribers_only',
  Free: 'free',
  MonthlyPrice: 'monthly_price',
} as const;

export type InlineResponse2006PaymentTypeEnum =
  typeof InlineResponse2006PaymentTypeEnum[keyof typeof InlineResponse2006PaymentTypeEnum];
export const InlineResponse2006PriceModelEnum = {
  Fixed: 'fixed',
  Auction: 'auction',
} as const;

export type InlineResponse2006PriceModelEnum =
  typeof InlineResponse2006PriceModelEnum[keyof typeof InlineResponse2006PriceModelEnum];

/**
 *
 * @export
 * @interface InlineResponse2006Config
 */
export interface InlineResponse2006Config {
  /**
   *
   * @type {InlineResponse2006ConfigChallenge}
   * @memberof InlineResponse2006Config
   */
  challenge?: InlineResponse2006ConfigChallenge | null;
  /**
   *
   * @type {InlineResponse2006ConfigLive}
   * @memberof InlineResponse2006Config
   */
  live?: InlineResponse2006ConfigLive | null;
  /**
   *
   * @type {InlineResponse2006ConfigChannel}
   * @memberof InlineResponse2006Config
   */
  channel?: InlineResponse2006ConfigChannel | null;
}
/**
 *
 * @export
 * @interface InlineResponse2006ConfigChallenge
 */
export interface InlineResponse2006ConfigChallenge {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2006ConfigChallenge
   */
  finishTimestamp?: number | null;
}
/**
 *
 * @export
 * @interface InlineResponse2006ConfigChannel
 */
export interface InlineResponse2006ConfigChannel {
  /**
   *
   * @type {string}
   * @memberof InlineResponse2006ConfigChannel
   */
  creatorDescription?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2006ConfigChannel
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2006ConfigChannel
   */
  targetAudience?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2006ConfigChannel
   */
  contentFormat?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2006ConfigChannel
   */
  updateFrequency?: InlineResponse2006ConfigChannelUpdateFrequencyEnum;
}

export const InlineResponse2006ConfigChannelUpdateFrequencyEnum = {
  Daily: 'daily',
  TwoThreePerWeek: 'twoThreePerWeek',
  Weekly: 'weekly',
  TwoThreePerMonth: 'twoThreePerMonth',
  Occasionally: 'occasionally',
} as const;

export type InlineResponse2006ConfigChannelUpdateFrequencyEnum =
  typeof InlineResponse2006ConfigChannelUpdateFrequencyEnum[keyof typeof InlineResponse2006ConfigChannelUpdateFrequencyEnum];

/**
 *
 * @export
 * @interface InlineResponse2006ConfigLive
 */
export interface InlineResponse2006ConfigLive {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2006ConfigLive
   */
  startAt?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2006ConfigLive
   */
  duration?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2006ConfigLive
   */
  linkToZoom?: string | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2006ConfigLive
   */
  requirements?: string | null;
  /**
   *
   * @type {InlineResponse2006ConfigLiveRecord}
   * @memberof InlineResponse2006ConfigLive
   */
  record?: InlineResponse2006ConfigLiveRecord | null;
  /**
   *
   * @type {Array<InlineResponse2006ConfigLiveTestimonials>}
   * @memberof InlineResponse2006ConfigLive
   */
  testimonials?: Array<InlineResponse2006ConfigLiveTestimonials>;
}
/**
 *
 * @export
 * @interface InlineResponse2006ConfigLiveRecord
 */
export interface InlineResponse2006ConfigLiveRecord {
  /**
   *
   * @type {object}
   * @memberof InlineResponse2006ConfigLiveRecord
   */
  meta?: object | null;
  /**
   *
   * @type {InlineResponse2006ConfigLiveRecordVideo}
   * @memberof InlineResponse2006ConfigLiveRecord
   */
  video?: InlineResponse2006ConfigLiveRecordVideo | null;
  /**
   *
   * @type {InlineResponse2006ConfigLiveRecordVideo}
   * @memberof InlineResponse2006ConfigLiveRecord
   */
  cover?: InlineResponse2006ConfigLiveRecordVideo | null;
}
/**
 *
 * @export
 * @interface InlineResponse2006ConfigLiveRecordVideo
 */
export interface InlineResponse2006ConfigLiveRecordVideo {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2006ConfigLiveRecordVideo
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2006ConfigLiveRecordVideo
   */
  url?: string;
}
/**
 *
 * @export
 * @interface InlineResponse2006ConfigLiveTestimonials
 */
export interface InlineResponse2006ConfigLiveTestimonials {
  /**
   *
   * @type {string}
   * @memberof InlineResponse2006ConfigLiveTestimonials
   */
  title?: string | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2006ConfigLiveTestimonials
   */
  authorName?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2006ConfigLiveTestimonials
   */
  review?: string;
  /**
   *
   * @type {InlineResponse2006ConfigLiveRecordVideo}
   * @memberof InlineResponse2006ConfigLiveTestimonials
   */
  avatar?: InlineResponse2006ConfigLiveRecordVideo | null;
}
/**
 *
 * @export
 * @interface InlineResponse2006MarketingPriceConfig
 */
export interface InlineResponse2006MarketingPriceConfig {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2006MarketingPriceConfig
   */
  previousPrice?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2006MarketingPriceConfig
   */
  iosPrice?: number;
}
/**
 *
 * @export
 * @interface InlineResponse2006Posts
 */
export interface InlineResponse2006Posts {
  /**
   *
   * @type {string}
   * @memberof InlineResponse2006Posts
   */
  type?: InlineResponse2006PostsTypeEnum;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2006Posts
   */
  order?: number;
  /**
   *
   * @type {object}
   * @memberof InlineResponse2006Posts
   */
  content?: object;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2006Posts
   */
  publishAt?: number | null;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2006Posts
   */
  isDraft?: boolean;
}

export const InlineResponse2006PostsTypeEnum = {
  Intro: 'intro',
  Step: 'step',
  Finish: 'finish',
  Deferred: 'deferred',
} as const;

export type InlineResponse2006PostsTypeEnum =
  typeof InlineResponse2006PostsTypeEnum[keyof typeof InlineResponse2006PostsTypeEnum];

/**
 *
 * @export
 * @interface InlineResponse2006Steps
 */
export interface InlineResponse2006Steps {
  /**
   *
   * @type {string}
   * @memberof InlineResponse2006Steps
   */
  title?: string;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2006Steps
   */
  startAt?: number | null;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2006Steps
   */
  isEnabled?: boolean;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2006Steps
   */
  estimatedEffort?: number;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2006Steps
   */
  isSignificant?: boolean;
  /**
   *
   * @type {Array<InlineResponse2006Posts>}
   * @memberof InlineResponse2006Steps
   */
  posts?: Array<InlineResponse2006Posts>;
}
/**
 *
 * @export
 * @interface InlineResponse2007
 */
export interface InlineResponse2007 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2007
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2007
   */
  created_at?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2007
   */
  updated_at?: number | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2007
   */
  title?: string;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2007
   */
  price?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2007
   */
  type?: InlineResponse2007TypeEnum;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2007
   */
  status?: InlineResponse2007StatusEnum;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2007
   */
  payment_type?: InlineResponse2007PaymentTypeEnum;
  /**
   *
   * @type {InlineResponse2007Config}
   * @memberof InlineResponse2007
   */
  config?: InlineResponse2007Config | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2007
   */
  slug?: string;
  /**
   *
   * @type {InlineResponse2006ConfigLiveRecordVideo}
   * @memberof InlineResponse2007
   */
  cover?: InlineResponse2006ConfigLiveRecordVideo | null;
  /**
   *
   * @type {InlineResponse2007Owner}
   * @memberof InlineResponse2007
   */
  owner?: InlineResponse2007Owner | null;
}

export const InlineResponse2007TypeEnum = {
  Post: 'post',
  Live: 'live',
  Challenge: 'challenge',
  Trailer: 'trailer',
  Channel: 'channel',
} as const;

export type InlineResponse2007TypeEnum = typeof InlineResponse2007TypeEnum[keyof typeof InlineResponse2007TypeEnum];
export const InlineResponse2007StatusEnum = {
  Draft: 'draft',
  Published: 'published',
} as const;

export type InlineResponse2007StatusEnum =
  typeof InlineResponse2007StatusEnum[keyof typeof InlineResponse2007StatusEnum];
export const InlineResponse2007PaymentTypeEnum = {
  FixedPrice: 'fixed_price',
  FixedPriceSubscribersOnly: 'fixed_price_subscribers_only',
  SubscribersOnly: 'subscribers_only',
  Free: 'free',
  MonthlyPrice: 'monthly_price',
} as const;

export type InlineResponse2007PaymentTypeEnum =
  typeof InlineResponse2007PaymentTypeEnum[keyof typeof InlineResponse2007PaymentTypeEnum];

/**
 *
 * @export
 * @interface InlineResponse2007Config
 */
export interface InlineResponse2007Config {
  /**
   *
   * @type {InlineResponse2007ConfigChallenge}
   * @memberof InlineResponse2007Config
   */
  challenge?: InlineResponse2007ConfigChallenge | null;
  /**
   *
   * @type {InlineResponse2007ConfigLive}
   * @memberof InlineResponse2007Config
   */
  live?: InlineResponse2007ConfigLive | null;
  /**
   *
   * @type {InlineResponse2006ConfigChannel}
   * @memberof InlineResponse2007Config
   */
  channel?: InlineResponse2006ConfigChannel | null;
}
/**
 *
 * @export
 * @interface InlineResponse2007ConfigChallenge
 */
export interface InlineResponse2007ConfigChallenge {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2007ConfigChallenge
   */
  finishTimestamp?: number | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2007ConfigChallenge
   */
  offerDescription?: string | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2007ConfigChallenge
   */
  offerSummary?: string | null;
}
/**
 *
 * @export
 * @interface InlineResponse2007ConfigLive
 */
export interface InlineResponse2007ConfigLive {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2007ConfigLive
   */
  startAt?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2007ConfigLive
   */
  duration?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2007ConfigLive
   */
  linkToZoom?: string | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2007ConfigLive
   */
  creatorDescription?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2007ConfigLive
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2007ConfigLive
   */
  requirements?: string | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2007ConfigLive
   */
  offerDescription?: string | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2007ConfigLive
   */
  offerSummary?: string | null;
  /**
   *
   * @type {InlineResponse2006ConfigLiveRecord}
   * @memberof InlineResponse2007ConfigLive
   */
  record?: InlineResponse2006ConfigLiveRecord | null;
  /**
   *
   * @type {Array<InlineResponse2006ConfigLiveTestimonials>}
   * @memberof InlineResponse2007ConfigLive
   */
  testimonials?: Array<InlineResponse2006ConfigLiveTestimonials>;
}
/**
 *
 * @export
 * @interface InlineResponse2007Owner
 */
export interface InlineResponse2007Owner {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2007Owner
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2007Owner
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2007Owner
   */
  description?: string | null;
  /**
   *
   * @type {InlineResponse2006ConfigLiveRecordVideo}
   * @memberof InlineResponse2007Owner
   */
  avatar?: InlineResponse2006ConfigLiveRecordVideo | null;
}
/**
 *
 * @export
 * @interface InlineResponse2008
 */
export interface InlineResponse2008 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2008
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2008
   */
  created_at?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2008
   */
  updated_at?: number | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2008
   */
  title?: string;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2008
   */
  price?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2008
   */
  type?: InlineResponse2008TypeEnum;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2008
   */
  status?: InlineResponse2008StatusEnum;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2008
   */
  payment_type?: InlineResponse2008PaymentTypeEnum;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2008
   */
  coverFileId?: number;
  /**
   *
   * @type {InlineResponse2007Config}
   * @memberof InlineResponse2008
   */
  config?: InlineResponse2007Config | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2008
   */
  slug?: string;
  /**
   *
   * @type {InlineResponse2006ConfigLiveRecordVideo}
   * @memberof InlineResponse2008
   */
  cover?: InlineResponse2006ConfigLiveRecordVideo | null;
  /**
   *
   * @type {InlineResponse2007Owner}
   * @memberof InlineResponse2008
   */
  owner?: InlineResponse2007Owner | null;
}

export const InlineResponse2008TypeEnum = {
  Post: 'post',
  Live: 'live',
  Challenge: 'challenge',
  Trailer: 'trailer',
  Channel: 'channel',
} as const;

export type InlineResponse2008TypeEnum = typeof InlineResponse2008TypeEnum[keyof typeof InlineResponse2008TypeEnum];
export const InlineResponse2008StatusEnum = {
  Draft: 'draft',
  Published: 'published',
} as const;

export type InlineResponse2008StatusEnum =
  typeof InlineResponse2008StatusEnum[keyof typeof InlineResponse2008StatusEnum];
export const InlineResponse2008PaymentTypeEnum = {
  FixedPrice: 'fixed_price',
  FixedPriceSubscribersOnly: 'fixed_price_subscribers_only',
  SubscribersOnly: 'subscribers_only',
  Free: 'free',
  MonthlyPrice: 'monthly_price',
} as const;

export type InlineResponse2008PaymentTypeEnum =
  typeof InlineResponse2008PaymentTypeEnum[keyof typeof InlineResponse2008PaymentTypeEnum];

/**
 *
 * @export
 * @interface InlineResponse2009
 */
export interface InlineResponse2009 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2009
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2009
   */
  created_at?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2009
   */
  updated_at?: number | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2009
   */
  title?: string;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2009
   */
  price?: number;
  /**
   *
   * @type {object}
   * @memberof InlineResponse2009
   */
  content?: object | null;
  /**
   *
   * @type {object}
   * @memberof InlineResponse2009
   */
  teaser?: object;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2009
   */
  type?: InlineResponse2009TypeEnum;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2009
   */
  status?: InlineResponse2009StatusEnum;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2009
   */
  payment_type?: InlineResponse2009PaymentTypeEnum;
  /**
   *
   * @type {SpacesConfig}
   * @memberof InlineResponse2009
   */
  config?: SpacesConfig | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2009
   */
  slug?: string;
  /**
   *
   * @type {InlineResponse2006ConfigLiveRecordVideo}
   * @memberof InlineResponse2009
   */
  cover?: InlineResponse2006ConfigLiveRecordVideo | null;
  /**
   *
   * @type {InlineResponse2007Owner}
   * @memberof InlineResponse2009
   */
  owner?: InlineResponse2007Owner | null;
}

export const InlineResponse2009TypeEnum = {
  Post: 'post',
  Live: 'live',
  Challenge: 'challenge',
  Trailer: 'trailer',
  Channel: 'channel',
} as const;

export type InlineResponse2009TypeEnum = typeof InlineResponse2009TypeEnum[keyof typeof InlineResponse2009TypeEnum];
export const InlineResponse2009StatusEnum = {
  Draft: 'draft',
  Published: 'published',
} as const;

export type InlineResponse2009StatusEnum =
  typeof InlineResponse2009StatusEnum[keyof typeof InlineResponse2009StatusEnum];
export const InlineResponse2009PaymentTypeEnum = {
  FixedPrice: 'fixed_price',
  FixedPriceSubscribersOnly: 'fixed_price_subscribers_only',
  SubscribersOnly: 'subscribers_only',
  Free: 'free',
  MonthlyPrice: 'monthly_price',
} as const;

export type InlineResponse2009PaymentTypeEnum =
  typeof InlineResponse2009PaymentTypeEnum[keyof typeof InlineResponse2009PaymentTypeEnum];

/**
 *
 * @export
 * @interface SpacesConfig
 */
export interface SpacesConfig {
  /**
   *
   * @type {InlineResponse2006ConfigChallenge}
   * @memberof SpacesConfig
   */
  challenge?: InlineResponse2006ConfigChallenge | null;
  /**
   *
   * @type {SpacesConfigLive}
   * @memberof SpacesConfig
   */
  live?: SpacesConfigLive | null;
}
/**
 *
 * @export
 * @interface SpacesConfig1
 */
export interface SpacesConfig1 {
  /**
   *
   * @type {InlineResponse2007ConfigChallenge}
   * @memberof SpacesConfig1
   */
  challenge?: InlineResponse2007ConfigChallenge | null;
  /**
   *
   * @type {SpacesConfig1Live}
   * @memberof SpacesConfig1
   */
  live?: SpacesConfig1Live | null;
  /**
   *
   * @type {InlineResponse2006ConfigChannel}
   * @memberof SpacesConfig1
   */
  channel?: InlineResponse2006ConfigChannel | null;
}
/**
 *
 * @export
 * @interface SpacesConfig1Live
 */
export interface SpacesConfig1Live {
  /**
   *
   * @type {number}
   * @memberof SpacesConfig1Live
   */
  startAt?: number;
  /**
   *
   * @type {number}
   * @memberof SpacesConfig1Live
   */
  duration?: number;
  /**
   *
   * @type {string}
   * @memberof SpacesConfig1Live
   */
  linkToZoom?: string | null;
  /**
   *
   * @type {string}
   * @memberof SpacesConfig1Live
   */
  creatorDescription?: string;
  /**
   *
   * @type {string}
   * @memberof SpacesConfig1Live
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof SpacesConfig1Live
   */
  requirements?: string | null;
  /**
   *
   * @type {string}
   * @memberof SpacesConfig1Live
   */
  offerDescription?: string | null;
  /**
   *
   * @type {string}
   * @memberof SpacesConfig1Live
   */
  offerSummary?: string | null;
  /**
   *
   * @type {SpacesSpaceIdConfigLiveRecord}
   * @memberof SpacesConfig1Live
   */
  record?: SpacesSpaceIdConfigLiveRecord | null;
  /**
   *
   * @type {Array<SpacesSpaceIdConfigLiveTestimonials>}
   * @memberof SpacesConfig1Live
   */
  testimonials?: Array<SpacesSpaceIdConfigLiveTestimonials>;
}
/**
 *
 * @export
 * @interface SpacesConfigLive
 */
export interface SpacesConfigLive {
  /**
   *
   * @type {number}
   * @memberof SpacesConfigLive
   */
  startAt?: number;
  /**
   *
   * @type {number}
   * @memberof SpacesConfigLive
   */
  duration?: number;
}
/**
 *
 * @export
 * @interface SpacesSpaceIdChallengePostsUpdated
 */
export interface SpacesSpaceIdChallengePostsUpdated {
  /**
   *
   * @type {number}
   * @memberof SpacesSpaceIdChallengePostsUpdated
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof SpacesSpaceIdChallengePostsUpdated
   */
  type?: SpacesSpaceIdChallengePostsUpdatedTypeEnum;
  /**
   *
   * @type {number}
   * @memberof SpacesSpaceIdChallengePostsUpdated
   */
  stepId?: number | null;
  /**
   *
   * @type {number}
   * @memberof SpacesSpaceIdChallengePostsUpdated
   */
  order?: number | null;
  /**
   *
   * @type {object}
   * @memberof SpacesSpaceIdChallengePostsUpdated
   */
  content?: object | null;
  /**
   *
   * @type {number}
   * @memberof SpacesSpaceIdChallengePostsUpdated
   */
  publishAt?: number | null;
  /**
   *
   * @type {boolean}
   * @memberof SpacesSpaceIdChallengePostsUpdated
   */
  isDraft?: boolean | null;
}

export const SpacesSpaceIdChallengePostsUpdatedTypeEnum = {
  Intro: 'intro',
  Step: 'step',
  Finish: 'finish',
  Deferred: 'deferred',
} as const;

export type SpacesSpaceIdChallengePostsUpdatedTypeEnum =
  typeof SpacesSpaceIdChallengePostsUpdatedTypeEnum[keyof typeof SpacesSpaceIdChallengePostsUpdatedTypeEnum];

/**
 *
 * @export
 * @interface SpacesSpaceIdChallengeResultsAvatar
 */
export interface SpacesSpaceIdChallengeResultsAvatar {
  /**
   *
   * @type {string}
   * @memberof SpacesSpaceIdChallengeResultsAvatar
   */
  url?: string | null;
}
/**
 *
 * @export
 * @interface SpacesSpaceIdChallengeStepsCreated
 */
export interface SpacesSpaceIdChallengeStepsCreated {
  /**
   *
   * @type {number}
   * @memberof SpacesSpaceIdChallengeStepsCreated
   */
  startAt?: number | null;
  /**
   *
   * @type {string}
   * @memberof SpacesSpaceIdChallengeStepsCreated
   */
  title?: string;
  /**
   *
   * @type {number}
   * @memberof SpacesSpaceIdChallengeStepsCreated
   */
  estimatedEffort?: number;
  /**
   *
   * @type {boolean}
   * @memberof SpacesSpaceIdChallengeStepsCreated
   */
  isEnabled?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof SpacesSpaceIdChallengeStepsCreated
   */
  isSignificant?: boolean;
}
/**
 *
 * @export
 * @interface SpacesSpaceIdChallengeStepsUpdated
 */
export interface SpacesSpaceIdChallengeStepsUpdated {
  /**
   *
   * @type {number}
   * @memberof SpacesSpaceIdChallengeStepsUpdated
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof SpacesSpaceIdChallengeStepsUpdated
   */
  startAt?: number | null;
  /**
   *
   * @type {string}
   * @memberof SpacesSpaceIdChallengeStepsUpdated
   */
  title?: string | null;
  /**
   *
   * @type {number}
   * @memberof SpacesSpaceIdChallengeStepsUpdated
   */
  estimatedEffort?: number | null;
  /**
   *
   * @type {boolean}
   * @memberof SpacesSpaceIdChallengeStepsUpdated
   */
  isEnabled?: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof SpacesSpaceIdChallengeStepsUpdated
   */
  isSignificant?: boolean | null;
}
/**
 *
 * @export
 * @interface SpacesSpaceIdConfig
 */
export interface SpacesSpaceIdConfig {
  /**
   *
   * @type {InlineResponse2007ConfigChallenge}
   * @memberof SpacesSpaceIdConfig
   */
  challenge?: InlineResponse2007ConfigChallenge | null;
  /**
   *
   * @type {SpacesSpaceIdConfigLive}
   * @memberof SpacesSpaceIdConfig
   */
  live?: SpacesSpaceIdConfigLive | null;
  /**
   *
   * @type {InlineResponse2006ConfigChannel}
   * @memberof SpacesSpaceIdConfig
   */
  channel?: InlineResponse2006ConfigChannel | null;
}
/**
 *
 * @export
 * @interface SpacesSpaceIdConfigLive
 */
export interface SpacesSpaceIdConfigLive {
  /**
   *
   * @type {number}
   * @memberof SpacesSpaceIdConfigLive
   */
  startAt?: number;
  /**
   *
   * @type {number}
   * @memberof SpacesSpaceIdConfigLive
   */
  duration?: number;
  /**
   *
   * @type {string}
   * @memberof SpacesSpaceIdConfigLive
   */
  linkToZoom?: string;
  /**
   *
   * @type {string}
   * @memberof SpacesSpaceIdConfigLive
   */
  requirements?: string | null;
  /**
   *
   * @type {string}
   * @memberof SpacesSpaceIdConfigLive
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof SpacesSpaceIdConfigLive
   */
  creatorDescription?: string;
  /**
   *
   * @type {string}
   * @memberof SpacesSpaceIdConfigLive
   */
  offerDescription?: string | null;
  /**
   *
   * @type {string}
   * @memberof SpacesSpaceIdConfigLive
   */
  offerSummary?: string | null;
  /**
   *
   * @type {SpacesSpaceIdConfigLiveRecord}
   * @memberof SpacesSpaceIdConfigLive
   */
  record?: SpacesSpaceIdConfigLiveRecord | null;
  /**
   *
   * @type {Array<SpacesSpaceIdConfigLiveTestimonials>}
   * @memberof SpacesSpaceIdConfigLive
   */
  testimonials?: Array<SpacesSpaceIdConfigLiveTestimonials>;
}
/**
 *
 * @export
 * @interface SpacesSpaceIdConfigLiveRecord
 */
export interface SpacesSpaceIdConfigLiveRecord {
  /**
   *
   * @type {number}
   * @memberof SpacesSpaceIdConfigLiveRecord
   */
  videoFileId?: number;
  /**
   *
   * @type {number}
   * @memberof SpacesSpaceIdConfigLiveRecord
   */
  coverFileId?: number | null;
  /**
   *
   * @type {object}
   * @memberof SpacesSpaceIdConfigLiveRecord
   */
  meta?: object | null;
}
/**
 *
 * @export
 * @interface SpacesSpaceIdConfigLiveTestimonials
 */
export interface SpacesSpaceIdConfigLiveTestimonials {
  /**
   *
   * @type {string}
   * @memberof SpacesSpaceIdConfigLiveTestimonials
   */
  title?: string | null;
  /**
   *
   * @type {string}
   * @memberof SpacesSpaceIdConfigLiveTestimonials
   */
  authorName?: string;
  /**
   *
   * @type {string}
   * @memberof SpacesSpaceIdConfigLiveTestimonials
   */
  review?: string;
  /**
   *
   * @type {number}
   * @memberof SpacesSpaceIdConfigLiveTestimonials
   */
  avatarFileId?: number | null;
}

/**
 * ChallengeApi - axios parameter creator
 * @export
 */
export const ChallengeApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} stepId
     * @param {InlineObject} [inlineObject]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    challengeStepsStepIdMovePost: async (
      stepId: number,
      inlineObject?: InlineObject,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'stepId' is not null or undefined
      assertParamExists('challengeStepsStepIdMovePost', 'stepId', stepId);
      const localVarPath = `/challenge/steps/{stepId}/move`.replace(
        `{${'stepId'}}`,
        encodeURIComponent(String(stepId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ChallengeApi - functional programming interface
 * @export
 */
export const ChallengeApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ChallengeApiAxiosParamCreator(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} stepId
     * @param {InlineObject} [inlineObject]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async challengeStepsStepIdMovePost(
      stepId: number,
      inlineObject?: InlineObject,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.challengeStepsStepIdMovePost(
        stepId,
        inlineObject,
        options,
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * ChallengeApi - factory interface
 * @export
 */
export const ChallengeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = ChallengeApiFp(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} stepId
     * @param {InlineObject} [inlineObject]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    challengeStepsStepIdMovePost(
      stepId: number,
      inlineObject?: InlineObject,
      options?: any,
    ): AxiosPromise<InlineResponse200> {
      return localVarFp
        .challengeStepsStepIdMovePost(stepId, inlineObject, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * ChallengeApi - object-oriented interface
 * @export
 * @class ChallengeApi
 * @extends {BaseAPI}
 */
export class ChallengeApi extends BaseAPI {
  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} stepId
   * @param {InlineObject} [inlineObject]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ChallengeApi
   */
  public challengeStepsStepIdMovePost(stepId: number, inlineObject?: InlineObject, options?: AxiosRequestConfig) {
    return ChallengeApiFp(this.configuration)
      .challengeStepsStepIdMovePost(stepId, inlineObject, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * SpacesApi - axios parameter creator
 * @export
 */
export const SpacesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Список всех спейсов эксперта <br /><br /> <b>Authentication:</b> required
     * @summary Список всех спейсов эксперта
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/spaces`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Создание нового спейса <br /><br /> <b>Authentication:</b> required
     * @summary Создание нового спейса
     * @param {InlineObject6} [inlineObject6]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesPost: async (inlineObject6?: InlineObject6, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/spaces`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject6, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdChallengePostsGet: async (spaceId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'spaceId' is not null or undefined
      assertParamExists('spacesSpaceIdChallengePostsGet', 'spaceId', spaceId);
      const localVarPath = `/spaces/{spaceId}/challenge/posts`.replace(
        `{${'spaceId'}}`,
        encodeURIComponent(String(spaceId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {InlineObject3} [inlineObject3]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdChallengePostsPatch: async (
      spaceId: number,
      inlineObject3?: InlineObject3,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'spaceId' is not null or undefined
      assertParamExists('spacesSpaceIdChallengePostsPatch', 'spaceId', spaceId);
      const localVarPath = `/spaces/{spaceId}/challenge/posts`.replace(
        `{${'spaceId'}}`,
        encodeURIComponent(String(spaceId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject3, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {InlineObject2} [inlineObject2]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdChallengePostsPost: async (
      spaceId: number,
      inlineObject2?: InlineObject2,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'spaceId' is not null or undefined
      assertParamExists('spacesSpaceIdChallengePostsPost', 'spaceId', spaceId);
      const localVarPath = `/spaces/{spaceId}/challenge/posts`.replace(
        `{${'spaceId'}}`,
        encodeURIComponent(String(spaceId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject2, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {number} postId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdChallengePostsPostIdDelete: async (
      spaceId: number,
      postId: number,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'spaceId' is not null or undefined
      assertParamExists('spacesSpaceIdChallengePostsPostIdDelete', 'spaceId', spaceId);
      // verify required parameter 'postId' is not null or undefined
      assertParamExists('spacesSpaceIdChallengePostsPostIdDelete', 'postId', postId);
      const localVarPath = `/spaces/{spaceId}/challenge/posts/{postId}`
        .replace(`{${'spaceId'}}`, encodeURIComponent(String(spaceId)))
        .replace(`{${'postId'}}`, encodeURIComponent(String(postId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {number} postId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdChallengePostsPostIdGet: async (
      spaceId: number,
      postId: number,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'spaceId' is not null or undefined
      assertParamExists('spacesSpaceIdChallengePostsPostIdGet', 'spaceId', spaceId);
      // verify required parameter 'postId' is not null or undefined
      assertParamExists('spacesSpaceIdChallengePostsPostIdGet', 'postId', postId);
      const localVarPath = `/spaces/{spaceId}/challenge/posts/{postId}`
        .replace(`{${'spaceId'}}`, encodeURIComponent(String(spaceId)))
        .replace(`{${'postId'}}`, encodeURIComponent(String(postId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} postId
     * @param {number} spaceId
     * @param {InlineObject1} [inlineObject1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdChallengePostsPostIdPost: async (
      postId: number,
      spaceId: number,
      inlineObject1?: InlineObject1,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'postId' is not null or undefined
      assertParamExists('spacesSpaceIdChallengePostsPostIdPost', 'postId', postId);
      // verify required parameter 'spaceId' is not null or undefined
      assertParamExists('spacesSpaceIdChallengePostsPostIdPost', 'spaceId', spaceId);
      const localVarPath = `/spaces/{spaceId}/challenge/posts/{postId}`
        .replace(`{${'postId'}}`, encodeURIComponent(String(postId)))
        .replace(`{${'spaceId'}}`, encodeURIComponent(String(spaceId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject1, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdChallengeResultsGet: async (
      spaceId: number,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'spaceId' is not null or undefined
      assertParamExists('spacesSpaceIdChallengeResultsGet', 'spaceId', spaceId);
      const localVarPath = `/spaces/{spaceId}/challenge/results`.replace(
        `{${'spaceId'}}`,
        encodeURIComponent(String(spaceId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Получение списка всех шагов челленджа <br /><br /> <b>Authentication:</b> required
     * @summary Получение списка всех шагов челленджа
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdChallengeStepsGet: async (spaceId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'spaceId' is not null or undefined
      assertParamExists('spacesSpaceIdChallengeStepsGet', 'spaceId', spaceId);
      const localVarPath = `/spaces/{spaceId}/challenge/steps`.replace(
        `{${'spaceId'}}`,
        encodeURIComponent(String(spaceId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Update challenge steps <br /><br /> <b>Authentication:</b> required
     * @summary Update challenge steps
     * @param {number} spaceId
     * @param {InlineObject4} [inlineObject4]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdChallengeStepsPatch: async (
      spaceId: number,
      inlineObject4?: InlineObject4,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'spaceId' is not null or undefined
      assertParamExists('spacesSpaceIdChallengeStepsPatch', 'spaceId', spaceId);
      const localVarPath = `/spaces/{spaceId}/challenge/steps`.replace(
        `{${'spaceId'}}`,
        encodeURIComponent(String(spaceId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject4, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdClonePost: async (spaceId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'spaceId' is not null or undefined
      assertParamExists('spacesSpaceIdClonePost', 'spaceId', spaceId);
      const localVarPath = `/spaces/{spaceId}/clone`.replace(`{${'spaceId'}}`, encodeURIComponent(String(spaceId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdDelete: async (spaceId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'spaceId' is not null or undefined
      assertParamExists('spacesSpaceIdDelete', 'spaceId', spaceId);
      const localVarPath = `/spaces/{spaceId}`.replace(`{${'spaceId'}}`, encodeURIComponent(String(spaceId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdGet: async (spaceId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'spaceId' is not null or undefined
      assertParamExists('spacesSpaceIdGet', 'spaceId', spaceId);
      const localVarPath = `/spaces/{spaceId}`.replace(`{${'spaceId'}}`, encodeURIComponent(String(spaceId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {InlineObject5} [inlineObject5]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdPatch: async (
      spaceId: number,
      inlineObject5?: InlineObject5,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'spaceId' is not null or undefined
      assertParamExists('spacesSpaceIdPatch', 'spaceId', spaceId);
      const localVarPath = `/spaces/{spaceId}`.replace(`{${'spaceId'}}`, encodeURIComponent(String(spaceId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject5, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * SpacesApi - functional programming interface
 * @export
 */
export const SpacesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = SpacesApiAxiosParamCreator(configuration);
  return {
    /**
     * Список всех спейсов эксперта <br /><br /> <b>Authentication:</b> required
     * @summary Список всех спейсов эксперта
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async spacesGet(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InlineResponse2009>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.spacesGet(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Создание нового спейса <br /><br /> <b>Authentication:</b> required
     * @summary Создание нового спейса
     * @param {InlineObject6} [inlineObject6]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async spacesPost(
      inlineObject6?: InlineObject6,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20010>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.spacesPost(inlineObject6, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async spacesSpaceIdChallengePostsGet(
      spaceId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InlineResponse2001>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.spacesSpaceIdChallengePostsGet(spaceId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {InlineObject3} [inlineObject3]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async spacesSpaceIdChallengePostsPatch(
      spaceId: number,
      inlineObject3?: InlineObject3,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InlineResponse2001>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.spacesSpaceIdChallengePostsPatch(
        spaceId,
        inlineObject3,
        options,
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {InlineObject2} [inlineObject2]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async spacesSpaceIdChallengePostsPost(
      spaceId: number,
      inlineObject2?: InlineObject2,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2001>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.spacesSpaceIdChallengePostsPost(
        spaceId,
        inlineObject2,
        options,
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {number} postId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async spacesSpaceIdChallengePostsPostIdDelete(
      spaceId: number,
      postId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.spacesSpaceIdChallengePostsPostIdDelete(
        spaceId,
        postId,
        options,
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {number} postId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async spacesSpaceIdChallengePostsPostIdGet(
      spaceId: number,
      postId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InlineResponse2001>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.spacesSpaceIdChallengePostsPostIdGet(
        spaceId,
        postId,
        options,
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} postId
     * @param {number} spaceId
     * @param {InlineObject1} [inlineObject1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async spacesSpaceIdChallengePostsPostIdPost(
      postId: number,
      spaceId: number,
      inlineObject1?: InlineObject1,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2002>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.spacesSpaceIdChallengePostsPostIdPost(
        postId,
        spaceId,
        inlineObject1,
        options,
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async spacesSpaceIdChallengeResultsGet(
      spaceId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InlineResponse2003>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.spacesSpaceIdChallengeResultsGet(spaceId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Получение списка всех шагов челленджа <br /><br /> <b>Authentication:</b> required
     * @summary Получение списка всех шагов челленджа
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async spacesSpaceIdChallengeStepsGet(
      spaceId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InlineResponse2004>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.spacesSpaceIdChallengeStepsGet(spaceId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Update challenge steps <br /><br /> <b>Authentication:</b> required
     * @summary Update challenge steps
     * @param {number} spaceId
     * @param {InlineObject4} [inlineObject4]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async spacesSpaceIdChallengeStepsPatch(
      spaceId: number,
      inlineObject4?: InlineObject4,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InlineResponse2005>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.spacesSpaceIdChallengeStepsPatch(
        spaceId,
        inlineObject4,
        options,
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async spacesSpaceIdClonePost(
      spaceId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2006>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.spacesSpaceIdClonePost(spaceId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async spacesSpaceIdDelete(
      spaceId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.spacesSpaceIdDelete(spaceId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async spacesSpaceIdGet(
      spaceId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2007>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.spacesSpaceIdGet(spaceId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {InlineObject5} [inlineObject5]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async spacesSpaceIdPatch(
      spaceId: number,
      inlineObject5?: InlineObject5,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2008>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.spacesSpaceIdPatch(spaceId, inlineObject5, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * SpacesApi - factory interface
 * @export
 */
export const SpacesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = SpacesApiFp(configuration);
  return {
    /**
     * Список всех спейсов эксперта <br /><br /> <b>Authentication:</b> required
     * @summary Список всех спейсов эксперта
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesGet(options?: any): AxiosPromise<Array<InlineResponse2009>> {
      return localVarFp.spacesGet(options).then(request => request(axios, basePath));
    },
    /**
     * Создание нового спейса <br /><br /> <b>Authentication:</b> required
     * @summary Создание нового спейса
     * @param {InlineObject6} [inlineObject6]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesPost(inlineObject6?: InlineObject6, options?: any): AxiosPromise<InlineResponse20010> {
      return localVarFp.spacesPost(inlineObject6, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdChallengePostsGet(spaceId: number, options?: any): AxiosPromise<Array<InlineResponse2001>> {
      return localVarFp.spacesSpaceIdChallengePostsGet(spaceId, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {InlineObject3} [inlineObject3]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdChallengePostsPatch(
      spaceId: number,
      inlineObject3?: InlineObject3,
      options?: any,
    ): AxiosPromise<Array<InlineResponse2001>> {
      return localVarFp
        .spacesSpaceIdChallengePostsPatch(spaceId, inlineObject3, options)
        .then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {InlineObject2} [inlineObject2]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdChallengePostsPost(
      spaceId: number,
      inlineObject2?: InlineObject2,
      options?: any,
    ): AxiosPromise<InlineResponse2001> {
      return localVarFp
        .spacesSpaceIdChallengePostsPost(spaceId, inlineObject2, options)
        .then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {number} postId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdChallengePostsPostIdDelete(spaceId: number, postId: number, options?: any): AxiosPromise<object> {
      return localVarFp
        .spacesSpaceIdChallengePostsPostIdDelete(spaceId, postId, options)
        .then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {number} postId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdChallengePostsPostIdGet(
      spaceId: number,
      postId: number,
      options?: any,
    ): AxiosPromise<Array<InlineResponse2001>> {
      return localVarFp
        .spacesSpaceIdChallengePostsPostIdGet(spaceId, postId, options)
        .then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} postId
     * @param {number} spaceId
     * @param {InlineObject1} [inlineObject1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdChallengePostsPostIdPost(
      postId: number,
      spaceId: number,
      inlineObject1?: InlineObject1,
      options?: any,
    ): AxiosPromise<InlineResponse2002> {
      return localVarFp
        .spacesSpaceIdChallengePostsPostIdPost(postId, spaceId, inlineObject1, options)
        .then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdChallengeResultsGet(spaceId: number, options?: any): AxiosPromise<Array<InlineResponse2003>> {
      return localVarFp.spacesSpaceIdChallengeResultsGet(spaceId, options).then(request => request(axios, basePath));
    },
    /**
     * Получение списка всех шагов челленджа <br /><br /> <b>Authentication:</b> required
     * @summary Получение списка всех шагов челленджа
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdChallengeStepsGet(spaceId: number, options?: any): AxiosPromise<Array<InlineResponse2004>> {
      return localVarFp.spacesSpaceIdChallengeStepsGet(spaceId, options).then(request => request(axios, basePath));
    },
    /**
     * Update challenge steps <br /><br /> <b>Authentication:</b> required
     * @summary Update challenge steps
     * @param {number} spaceId
     * @param {InlineObject4} [inlineObject4]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdChallengeStepsPatch(
      spaceId: number,
      inlineObject4?: InlineObject4,
      options?: any,
    ): AxiosPromise<Array<InlineResponse2005>> {
      return localVarFp
        .spacesSpaceIdChallengeStepsPatch(spaceId, inlineObject4, options)
        .then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdClonePost(spaceId: number, options?: any): AxiosPromise<InlineResponse2006> {
      return localVarFp.spacesSpaceIdClonePost(spaceId, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdDelete(spaceId: number, options?: any): AxiosPromise<object> {
      return localVarFp.spacesSpaceIdDelete(spaceId, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdGet(spaceId: number, options?: any): AxiosPromise<InlineResponse2007> {
      return localVarFp.spacesSpaceIdGet(spaceId, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {InlineObject5} [inlineObject5]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdPatch(
      spaceId: number,
      inlineObject5?: InlineObject5,
      options?: any,
    ): AxiosPromise<InlineResponse2008> {
      return localVarFp.spacesSpaceIdPatch(spaceId, inlineObject5, options).then(request => request(axios, basePath));
    },
  };
};

/**
 * SpacesApi - object-oriented interface
 * @export
 * @class SpacesApi
 * @extends {BaseAPI}
 */
export class SpacesApi extends BaseAPI {
  /**
   * Список всех спейсов эксперта <br /><br /> <b>Authentication:</b> required
   * @summary Список всех спейсов эксперта
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SpacesApi
   */
  public spacesGet(options?: AxiosRequestConfig) {
    return SpacesApiFp(this.configuration)
      .spacesGet(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Создание нового спейса <br /><br /> <b>Authentication:</b> required
   * @summary Создание нового спейса
   * @param {InlineObject6} [inlineObject6]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SpacesApi
   */
  public spacesPost(inlineObject6?: InlineObject6, options?: AxiosRequestConfig) {
    return SpacesApiFp(this.configuration)
      .spacesPost(inlineObject6, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} spaceId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SpacesApi
   */
  public spacesSpaceIdChallengePostsGet(spaceId: number, options?: AxiosRequestConfig) {
    return SpacesApiFp(this.configuration)
      .spacesSpaceIdChallengePostsGet(spaceId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} spaceId
   * @param {InlineObject3} [inlineObject3]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SpacesApi
   */
  public spacesSpaceIdChallengePostsPatch(
    spaceId: number,
    inlineObject3?: InlineObject3,
    options?: AxiosRequestConfig,
  ) {
    return SpacesApiFp(this.configuration)
      .spacesSpaceIdChallengePostsPatch(spaceId, inlineObject3, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} spaceId
   * @param {InlineObject2} [inlineObject2]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SpacesApi
   */
  public spacesSpaceIdChallengePostsPost(spaceId: number, inlineObject2?: InlineObject2, options?: AxiosRequestConfig) {
    return SpacesApiFp(this.configuration)
      .spacesSpaceIdChallengePostsPost(spaceId, inlineObject2, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} spaceId
   * @param {number} postId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SpacesApi
   */
  public spacesSpaceIdChallengePostsPostIdDelete(spaceId: number, postId: number, options?: AxiosRequestConfig) {
    return SpacesApiFp(this.configuration)
      .spacesSpaceIdChallengePostsPostIdDelete(spaceId, postId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} spaceId
   * @param {number} postId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SpacesApi
   */
  public spacesSpaceIdChallengePostsPostIdGet(spaceId: number, postId: number, options?: AxiosRequestConfig) {
    return SpacesApiFp(this.configuration)
      .spacesSpaceIdChallengePostsPostIdGet(spaceId, postId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} postId
   * @param {number} spaceId
   * @param {InlineObject1} [inlineObject1]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SpacesApi
   */
  public spacesSpaceIdChallengePostsPostIdPost(
    postId: number,
    spaceId: number,
    inlineObject1?: InlineObject1,
    options?: AxiosRequestConfig,
  ) {
    return SpacesApiFp(this.configuration)
      .spacesSpaceIdChallengePostsPostIdPost(postId, spaceId, inlineObject1, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} spaceId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SpacesApi
   */
  public spacesSpaceIdChallengeResultsGet(spaceId: number, options?: AxiosRequestConfig) {
    return SpacesApiFp(this.configuration)
      .spacesSpaceIdChallengeResultsGet(spaceId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Получение списка всех шагов челленджа <br /><br /> <b>Authentication:</b> required
   * @summary Получение списка всех шагов челленджа
   * @param {number} spaceId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SpacesApi
   */
  public spacesSpaceIdChallengeStepsGet(spaceId: number, options?: AxiosRequestConfig) {
    return SpacesApiFp(this.configuration)
      .spacesSpaceIdChallengeStepsGet(spaceId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Update challenge steps <br /><br /> <b>Authentication:</b> required
   * @summary Update challenge steps
   * @param {number} spaceId
   * @param {InlineObject4} [inlineObject4]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SpacesApi
   */
  public spacesSpaceIdChallengeStepsPatch(
    spaceId: number,
    inlineObject4?: InlineObject4,
    options?: AxiosRequestConfig,
  ) {
    return SpacesApiFp(this.configuration)
      .spacesSpaceIdChallengeStepsPatch(spaceId, inlineObject4, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} spaceId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SpacesApi
   */
  public spacesSpaceIdClonePost(spaceId: number, options?: AxiosRequestConfig) {
    return SpacesApiFp(this.configuration)
      .spacesSpaceIdClonePost(spaceId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} spaceId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SpacesApi
   */
  public spacesSpaceIdDelete(spaceId: number, options?: AxiosRequestConfig) {
    return SpacesApiFp(this.configuration)
      .spacesSpaceIdDelete(spaceId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} spaceId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SpacesApi
   */
  public spacesSpaceIdGet(spaceId: number, options?: AxiosRequestConfig) {
    return SpacesApiFp(this.configuration)
      .spacesSpaceIdGet(spaceId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} spaceId
   * @param {InlineObject5} [inlineObject5]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SpacesApi
   */
  public spacesSpaceIdPatch(spaceId: number, inlineObject5?: InlineObject5, options?: AxiosRequestConfig) {
    return SpacesApiFp(this.configuration)
      .spacesSpaceIdPatch(spaceId, inlineObject5, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * UploadApi - axios parameter creator
 * @export
 */
export const UploadApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Загрузка изображений <br /><br /> <b>Authentication:</b> required
     * @summary Загрузка изображений
     * @param {any} [image]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadImagePost: async (image?: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/upload/image`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (image !== undefined) {
        localVarFormParams.append('image', image as any);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Загрузка видео <br /><br /> <b>Authentication:</b> required
     * @summary Загрузка видео
     * @param {any} [video]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadVideoPost: async (video?: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/upload/video`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (video !== undefined) {
        localVarFormParams.append('video', video as any);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UploadApi - functional programming interface
 * @export
 */
export const UploadApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = UploadApiAxiosParamCreator(configuration);
  return {
    /**
     * Загрузка изображений <br /><br /> <b>Authentication:</b> required
     * @summary Загрузка изображений
     * @param {any} [image]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async uploadImagePost(
      image?: any,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20011>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.uploadImagePost(image, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Загрузка видео <br /><br /> <b>Authentication:</b> required
     * @summary Загрузка видео
     * @param {any} [video]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async uploadVideoPost(
      video?: any,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20011>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.uploadVideoPost(video, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * UploadApi - factory interface
 * @export
 */
export const UploadApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = UploadApiFp(configuration);
  return {
    /**
     * Загрузка изображений <br /><br /> <b>Authentication:</b> required
     * @summary Загрузка изображений
     * @param {any} [image]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadImagePost(image?: any, options?: any): AxiosPromise<InlineResponse20011> {
      return localVarFp.uploadImagePost(image, options).then(request => request(axios, basePath));
    },
    /**
     * Загрузка видео <br /><br /> <b>Authentication:</b> required
     * @summary Загрузка видео
     * @param {any} [video]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadVideoPost(video?: any, options?: any): AxiosPromise<InlineResponse20011> {
      return localVarFp.uploadVideoPost(video, options).then(request => request(axios, basePath));
    },
  };
};

/**
 * UploadApi - object-oriented interface
 * @export
 * @class UploadApi
 * @extends {BaseAPI}
 */
export class UploadApi extends BaseAPI {
  /**
   * Загрузка изображений <br /><br /> <b>Authentication:</b> required
   * @summary Загрузка изображений
   * @param {any} [image]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UploadApi
   */
  public uploadImagePost(image?: any, options?: AxiosRequestConfig) {
    return UploadApiFp(this.configuration)
      .uploadImagePost(image, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Загрузка видео <br /><br /> <b>Authentication:</b> required
   * @summary Загрузка видео
   * @param {any} [video]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UploadApi
   */
  public uploadVideoPost(video?: any, options?: AxiosRequestConfig) {
    return UploadApiFp(this.configuration)
      .uploadVideoPost(video, options)
      .then(request => request(this.axios, this.basePath));
  }
}
